import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// import "./index.css";
import "react-toastify/dist/ReactToastify.min.css";
import "url-search-params-polyfill";
import "./lib/array-find-polyfill";
// import * as serviceWorker from "./serviceWorker";

import AppContainer from "./components/AppContainer/AppContainer";
import store from "./store";
import { isProduction } from "./lib/utils";
import { GoogleOAuthProvider } from "@react-oauth/google";

// Sentry code initialization

if (isProduction()) {
    Sentry.init({
        dsn: "https://ffe4617ef3ff4e9187e216f012b5fb5c@o359183.ingest.sentry.io/6422846",
        integrations: [new BrowserTracing()],
        tracesSampleRate: 1.0,
    });
}

ReactDOM.render(
    // <GoogleOAuthProvider clientId="626488198253-v37qlu0s8mc6qt43jj6u2k1asfqfvu7e.apps.googleusercontent.com">
    <Provider store={store}>
        <AppContainer />
    </Provider>,
    // </GoogleOAuthProvider>,
    document.getElementById("root"),
);
// const root= ReactDOM.createRoot(
//     document.getElementById("root")
// );
// root.render(
// <Provider store={store}>
//     {}
//         <AppContainer />
//     </Provider>
// )

// serviceWorker.register();
